import { useContext, type ComponentProps } from 'react';
import { ThemeContext } from 'styled-components';
import PhoneIcon from './PhoneIcon';

/** Phone glyph for a call that has both a primary and a secondary location. */
export default function AssociatedPhoneIcon(
  props: ComponentProps<typeof PhoneIcon>,
) {
  const theme = useContext(ThemeContext);
  return <PhoneIcon {...props} color={theme?.colors?.lightWarning} />;
}
